import { Stack, Typography, useMediaQuery, useTheme, Tooltip } from '@mui/material';
import Box from '@mui/material/Box';

import { Mail01Icon } from '@/assets/icons/Mail01Icon';
import { PhoneIcon } from '@/assets/icons/PhoneIcon';
import { usePropertyManager } from '@/context/PropertyManagerProvider';
import { formatPhoneNumber } from '@/utils/phone';

const HeaderContent: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isExtraSmall = useMediaQuery(theme.breakpoints.down('sm'));
  const { selectedPropertyLocation } = usePropertyManager();

  const iconFontSize: 'inherit' | 'small' | 'medium' = (() => {
    if (isExtraSmall) {
      return 'inherit';
    }
    if (isMobile) {
      return 'small';
    }
    return 'medium';
  })();

  const typographyVariant: 'caption' | 'body2' | 'body1' = (() => {
    if (isExtraSmall) {
      return 'caption';
    }
    if (isMobile) {
      return 'body2';
    }
    return 'body1';
  })();

  return (
    <>
      <Box sx={{ width: '100%', ml: 1 }} />

      {selectedPropertyLocation && (
        <Stack
          spacing={0.25}
          alignItems="flex-end"
          sx={{
            mr: { xs: 1, sm: 2 },
            maxWidth: { xs: '150px', sm: '180px', md: '300px' },
          }}
        >
          {!!selectedPropertyLocation.email && (
            <Tooltip title="Your Location Email" placement="left" arrow>
              <Stack direction="row" alignItems="center" spacing={0.5}>
                <Mail01Icon
                  fontSize={iconFontSize}
                  sx={{
                    fontSize: {
                      xs: '0.875rem',
                      sm: '1rem',
                      md: '1.25rem',
                    },
                  }}
                />
                <Typography
                  variant={typographyVariant}
                  sx={{
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    maxWidth: '100%',
                    fontSize: {
                      xs: '0.6875rem',
                      sm: '0.75rem',
                      md: '0.875rem',
                    },
                  }}
                >
                  {selectedPropertyLocation.email.value}
                </Typography>
              </Stack>
            </Tooltip>
          )}

          {!!selectedPropertyLocation.phone && (
            <Tooltip title="Your Location Phone" placement="left" arrow>
              <Stack direction="row" alignItems="center" spacing={0.5}>
                <PhoneIcon
                  fontSize={iconFontSize}
                  sx={{
                    fontSize: {
                      xs: '0.875rem',
                      sm: '1rem',
                      md: '1.25rem',
                    },
                  }}
                />
                <Typography
                  variant={typographyVariant}
                  sx={{
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    fontSize: {
                      xs: '0.6875rem',
                      sm: '0.75rem',
                      md: '0.875rem',
                    },
                  }}
                >
                  {formatPhoneNumber(selectedPropertyLocation.phone.value)}
                </Typography>
              </Stack>
            </Tooltip>
          )}
        </Stack>
      )}

      {/* {!downLG && <FullScreen />} */}
      {/* <Profile /> */}
    </>
  );
};

export default HeaderContent;
